import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { NO_META } from "@/constants";

import { getModules } from "@services/http/members";
import { ListModulesStoreProps, ListModulesStoreState } from "./ListModules.types";

const initialState: ListModulesStoreState = {
  data: [],
  meta: NO_META,
  isLoading: false,
  search: "",
  selectedModule: undefined,
};

export const useListModulesStore = create<ListModulesStoreProps>()(
  devtools(set => ({
    ...initialState,

    setModules: pagination => set(pagination),

    setSelectedModule: selectedModule => set({ selectedModule }),

    list: async () => {
      set({ ...initialState, isLoading: true });

      try {
        const response = await getModules({ pageSize: 99, page: 1 });
        const { data } = response;

        set({ data: data.data, isLoading: false });
      } catch (error) {
        set({ isLoading: false });
      }
    },

    setSearch: (search: string) => {
      set({ search });
    },
  }))
);
